import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=1549d917&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=1549d917&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports